<!--
 * @Author: yangxu yangxu@staff.hexun.com
 * @Date: 2025-02-17 10:17:20
 * @LastEditors: yangxu yangxu@staff.hexun.com
 * @LastEditTime: 2025-03-13 09:28:47
 * @FilePath: /js_celue-zuhe_src/src/components/noRight.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <CombinationIncome v-if="showYieldCurve == 1"></CombinationIncome>
  </div>
  <div class="position commonBox">
    <div class="title">组合仓位</div>
    <div class="clockBox">
      <div>
        <span></span>
        <p>下方订阅后查看详情</p>
      </div>
    </div>
  </div>
  <div class="transfer commonBox" v-if="list && list.length > 0">
    <div class="title">最近调仓</div>
    <div class="transferBox">
      <div class="transferList" v-for="item in list">
        <div
          class="type"
          :class="{ sell: item.entrust_bs != 1, buy: item.entrust_bs == 1 }"
        >
          {{ item.entrust_bs == 1 ? "买" : "卖" }}
        </div>
        <div>***</div>
        <div>
          <div>仓位</div>
          <div>***</div>
        </div>
        <div>
          <div>价格</div>
          <div>***</div>
        </div>
        <div class="time">
          {{ item.init_date.slice(5) }} {{ item.time.slice(0, 5) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
/******************************
 * 模块导入区（按类型分组）
 ******************************/
// Vue 核心
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";

// 组件
import CombinationIncome from "./CombinationIncome.vue";

// 工具函数
import { getUrlParam, parseJSONP, formatBusinessTime } from "@/utils/Util";

// API
import { getDetail } from "@/api/index";

/******************************
 * 常量定义
 ******************************/
const API_PATH = "410011"; // API路径常量化

/******************************
 * 初始化配置
 ******************************/
const store = useStore();
const id = getUrlParam("id");

/******************************
 * 响应式数据
 ******************************/
const list = ref([]);
const isLoading = ref(false); // 新增加载状态
const isAllLoaded = ref(false); // 新增全部加载完成标识
const error = ref(null); // 新增错误处理

// 从Vuex获取状态（使用计算属性）
const showYieldCurve = computed(
  () => //NOSONAR
    // 从Vuex获取是否显示收益率
    store.state.infos?.showYieldCurve
);
const fund_account = computed(
  () => //NOSONAR
    // 从Vuex获取基金账号
    store.state.list?.config?.fund_account || ""
);

/******************************
 * 请求参数配置
 ******************************/
const requestParams = ref({
  product_id: id,
  fund_account: fund_account.value, // 直接使用响应式值
  position: 0,
  count: 3,
});

/******************************
 * 生命周期钩子
 ******************************/
onMounted(() => { //NOSONAR
  console.log("combinationTransfer initialized");
  // 初始化数据
  initializeData();
});

/******************************
 * 核心方法
 ******************************/
const initializeData = async () => {
  try {
    await fetchTransactionData();
  } catch (err) {
    handleError(err);
  }
};

/******************************
 * 数据获取逻辑
 ******************************/
const fetchTransactionData = async () => {
  if (isLoading.value || isAllLoaded.value) return;

  isLoading.value = true;
  error.value = null;

  try {
    const response = await getDetail(
      API_PATH,
      JSON.stringify(requestParams.value)
    );
    const result = parseJSONP(response);

    if (result.code !== "0000") {
      console.log("API返回错误码：" + result.code);
    }

    processResponseData(result.result);
  } catch (err) {
    handleError(err);
  } finally {
    isLoading.value = false;
  }
};

/******************************
 * 数据处理逻辑
 ******************************/
const processResponseData = (data) => {
  if (!data || data.length === 0) {
    isAllLoaded.value = true;
    return;
  }

  const processedData = data.map((item) => ({
    ...item,
    time: formatBusinessTime(item.business_time), // 使用工具函数
  }));

  list.value = [...list.value, ...processedData];
  updatePagination(data);
};

/******************************
 * 分页处理
 ******************************/
const updatePagination = (data) => {
  if (data.length < requestParams.value.count) {
    isAllLoaded.value = true;
  } else {
    requestParams.value.position = data[data.length - 1].position;
  }
};

/******************************
 * 错误处理
 ******************************/
const handleError = (err) => {
  console.error("数据获取失败:", err);
  error.value = {
    message: "数据加载失败，请稍后重试",
    details: err.message,
  };
  // 可在此添加错误上报逻辑
};
</script>
<style lang="scss" scoped>
.commonBox {
  margin-top: calc(
    var(--imgfontSize) * 20
  ); /* 10px -> calc(var(--imgfontSize) * 20) */
  background: #fff;
  border-radius: calc(
    var(--imgfontSize) * 20
  ); /* 10px -> calc(var(--imgfontSize) * 20) */
  padding: calc(var(--imgfontSize) * 48) 0 calc(var(--imgfontSize) * 24); /* 24px, 12px -> calc(var(--imgfontSize) * 48), calc(var(--imgfontSize) * 24) */

  .title {
    font-size: calc(
      var(--imgfontSize) * 36
    ); /* 18px -> calc(var(--imgfontSize) * 36) */
    line-height: calc(
      var(--imgfontSize) * 40
    ); /* 20px -> calc(var(--imgfontSize) * 40) */
    color: #111;
    font-weight: 500;
  }
}

.position {
  .title {
    padding: 0 calc(var(--imgfontSize) * 30); /* 15px -> calc(var(--imgfontSize) * 30) */
  }

  .clockBox {
    background: url("~@/assets/img/no_right_position.png") no-repeat;
    width: 100%;
    height: calc(
      var(--imgfontSize) * 198
    ); /* 99px -> calc(var(--imgfontSize) * 198) */
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: 100%;

    & > div {
      display: flex;
      font-size: calc(
        var(--imgfontSize) * 28
      ); /* 14px -> calc(var(--imgfontSize) * 28) */
      color: #ff3f33;
      line-height: calc(
        var(--imgfontSize) * 40
      ); /* 20px -> calc(var(--imgfontSize) * 40) */
      align-items: center;
    }

    span {
      width: calc(
        var(--imgfontSize) * 40
      ); /* 20px -> calc(var(--imgfontSize) * 40) */
      height: calc(
        var(--imgfontSize) * 40
      ); /* 20px -> calc(var(--imgfontSize) * 40) */
      background: url("~@/assets/img/clock.png") no-repeat;
      background-size: 100%;
    }
  }
}

.transfer {
  padding-left: calc(
    var(--imgfontSize) * 30
  ); /* 15px -> calc(var(--imgfontSize) * 30) */
  padding-right: calc(
    var(--imgfontSize) * 30
  ); /* 15px -> calc(var(--imgfontSize) * 30) */
  padding-bottom: calc(
    var(--imgfontSize) * 8
  ); /* 4px -> calc(var(--imgfontSize) * 8) */

  .title {
    margin-bottom: calc(
      var(--imgfontSize) * 30
    ); /* 15px -> calc(var(--imgfontSize) * 30) */
  }

  .transferList {
    display: flex;
    font-size: calc(
      var(--imgfontSize) * 32
    ); /* 16px -> calc(var(--imgfontSize) * 32) */
    line-height: calc(
      var(--imgfontSize) * 40
    ); /* 20px -> calc(var(--imgfontSize) * 40) */
    align-items: center;
    color: #111;
    margin-bottom: calc(
      var(--imgfontSize) * 40
    ); /* 20px -> calc(var(--imgfontSize) * 40) */

    & > div {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: calc(
        var(--imgfontSize) * 32
      ); /* 16px -> calc(var(--imgfontSize) * 32) */
    }

    .type {
      width: calc(
        var(--imgfontSize) * 48
      ); /* 24px -> calc(var(--imgfontSize) * 48) */
      height: calc(
        var(--imgfontSize) * 48
      ); /* 24px -> calc(var(--imgfontSize) * 48) */
      font-size: calc(
        var(--imgfontSize) * 28
      ); /* 14px -> calc(var(--imgfontSize) * 28) */
      border-radius: 50%;
      line-height: calc(
        var(--imgfontSize) * 48
      ); /* 24px -> calc(var(--imgfontSize) * 48) */
      text-align: center;
      color: #fff;
      margin-right: calc(
        var(--imgfontSize) * 14
      ); /* 7px -> calc(var(--imgfontSize) * 14) */
    }

    .sell {
      background: linear-gradient(180deg, #4abb73 0%, #59d988 100%);
    }

    .buy {
      background: linear-gradient(180deg, #e82d23 0%, #fb3e3f 100%);
    }

    .time {
      margin-left: auto;
    }
  }
}
</style>
